import styled from 'styled-components'
import { softGray, blue, lightGray, mildGray, menuShadow } from '../../styles/variables.js'

const Tabs = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ noMargin }) => noMargin ? 0 : '20px'};
  flex: 1 1;
  &.leftTabs {
    flex-direction: row;
    margin-top: 0;
  }
`

const Tab = styled.div`

  padding: 8px 16px;
  min-width: 140px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  &.withEdit {
    justify-content: space-between;
  }

  @media (max-width: 1120px) {
    min-width: auto;
  }

  &.inactive {
    color: ${lightGray};
    border-radius: 6px;
    border: 2px solid ${softGray};
    margin: 0 10px 10px 0;
    cursor: pointer;

    &:first-child {
      margin: 0 10px 10px 0;
    }

    &:hover {
      opacity: 0.7;
    }

    @media (max-width: 1120px) {
      margin: 0 2px;
      border-bottom: none;
      border-radius: 6px 6px 0 0;
    }

    &.inverted {
      border: 2px solid white;

      @media (max-width: 1120px) {
        margin: 4px;
        border-radius: 6px;
      }
    }

    &.error {
      border: 2px solid red;
    }
  }

  &.active {
    color: ${blue};
    background: ${softGray};
    border-radius: 6px 6px 0 0;
    margin-right: 10px;

    &:first-child {
      border-radius: 6px 6px 0 0;
    }

    padding-bottom: 18px;

    @media (max-width: 1120px) {
      margin: 0;
      border-bottom: none;
      border-radius: 6px 6px 0 0;
      padding-bottom: 8px;
    }

    &.inverted {
      background: white;
    }
    &.leftTabs {
      border-radius: 6px 0 0 6px;
      margin-bottom: 10px;
      padding-bottom: 10px;

      @media (max-width: 1120px) {
        margin: 4px 0;
      }
    }
  }
`

const TabsHeader = styled.div`
  display: flex;
  flex-direction: row;
  &.inverted {
    background: ${softGray};
  }
  &.leftTabs {
    flex-direction: column;
  }
`
const TabsContent = styled.div`
  background: ${softGray};
  padding: 10px;
  border-radius: 6px;
  overflow-y: auto;
  position: relative;

  &.firstSelected {
    border-radius: 0 6px 6px 6px;
  }

  &.fullHeight {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    & > div {
      flex: 1 1;
    }
  }

  &.inverted {
    background: white;
  }

  &.invertedControls {
    input, textarea, select {
      background: ${softGray};
    }
  }

  &.leftTabs {
    flex: 1 1;
  }

  @media (max-width: 1120px) {
    padding: 4px;
  }
`

const Icon = styled.div`
  cursor: pointer;
  transition: all .1s ease-in-out;
  color: ${mildGray};
  padding: 0;
  margin-left: 12px;

  &:hover {
    transform: scale(1.1);
    color: black;
  }
`

const Delete = styled.div`
  background: white;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  left: -5px;
  cursor: pointer;
  color: ${mildGray};
  overflow: hidden;
  display: flex;
  flex-direction: row;
  box-shadow: ${menuShadow};
  font-size: 18px;
  &:hover {
    transform: scale(1.1);
    color: red;
  }
`

const Menu = styled.div`
  position: absolute;
  top: 100%;
  margin-top: -8px;
  background: white;
  padding: 8px 0;
  box-shadow: ${menuShadow};
  border-radius: 6px;
  z-index: 4;
  min-width: calc(100% - 10px);
  text-align: left;
`

const MenuItem = styled.div`
  padding: 8px 32px;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    background: ${softGray};
  }
`

export default {
  Tab,
  Tabs,
  TabsHeader,
  TabsContent,
  Icon,
  Delete,
  Menu,
  MenuItem,
}
